import { Button, Card, Col, message, Pagination, Row } from "antd";
import Title from "antd/es/typography/Title";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { match } from "ts-pattern";
import { useGetOrganization } from "../../../../api/v1";
import { useGridReset } from "../../../../hooks/useGridReset";
import { OwnerFilterConfig, OwnerSelectOption, useGetOwners } from "../../../../hooks/useGetOwners";
import { SelectOption } from "../../../../types/select";
import { dateByformat } from "../../../../utils/dateHelper";
import { getGridSettings } from "../../../../utils/globalService";
import Grid from "../../../atoms/Grid";
import DragAndDropList from "../../../atoms/Grid/gridColumnSort";
import { Popup, PopupTitle } from "../../../atoms/Popup";
import { DATE_FORMATS } from "../../../libs/utils";
import DashboardLayout from "../../../molecules/DashboardLayout";
import { DocumentViewer } from "../../../molecules/Documents";
import SideDrawer from "../../../molecules/SideDrawer";
import { Modal } from "../../BookingForm/components";
import Loader from "../../Loader.tsx";
import { getPropertiesDrop } from "../../Properties/ducks/actions";
import { paymentModes, usageTypeOptions } from "../../Properties/ducks/constants";
import { emptyPropertyUnits, getPropertyUnits } from "../../Properties/PropertyDetail/ducks/actions";
import ModifyPaymentStatus from "../PostDatedCheques/ModifyPaymentStatus";
import ChequeClearModal from "../PostDatedCheques/ModifyPaymentStatus/ChequeClearModal";
import DeferChequeDeposit from "../PostDatedCheques/ModifyPaymentStatus/DeferChequeDeposit";
import { RecallCheque } from "../PostDatedCheques/RecallCheque";
import { ReceiptConfirmation } from "../PostDatedCheques/ReceiptConfirmation";
import { getReceiptList, postReceiptChequeClear, postReceiptExport } from "./api/receiptActions";
import { BulkClearedReceiptsConfirm } from "./BulkClearedReceiptsConfirm";
import { buildReceiptColumns, receiptColumnDefs } from "./receiptColumns";
import { RECEIPT_EXPORT_COLUMNS } from "./receiptExportColumns";
import ReceiptsAdditionalFilters from "./ReceiptsAdditionalFilters";
import ReceiptsHeader from "./ReceiptsHeader";
import { useSearchParams, useNavigate } from "react-router-dom";
import {
  defaultSettings,
  isReceiptBulkSelectionRow,
  normalizeReceiptRow,
  PropertyOption,
  receiptExportColumns,
  receiptsStatusOptions,
} from "./utils";
import { isReceiptsModuleEnabled } from "../../../../utils/isReceiptsModuleEnabled";

const _ = require("lodash");

const allUsageTypeOpt: SelectOption = { label: "All", value: "all" };
const receiptsUsageTypeOptions: SelectOption[] = [allUsageTypeOpt, ...usageTypeOptions];
const defaultUsageType = allUsageTypeOpt.value;
// const defaultPaymentTypeOpt: SelectOption = { label: "All", value: "all" };

const Receipts: React.FC = () => {
  const { organization } = useGetOrganization();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const paymentReceiptId = searchParams.get("paymentReceiptId");
  const { resetGrid, setGridReset } = useGridReset();
  const dispatch: any = useDispatch();
  const pdcListState = useSelector((state: any) => state.contracts.pdcList);
  const isReceiptEnabled = isReceiptsModuleEnabled(organization);
  const initialState = {
    modalPayload: {
      iKey: "",
      title: "",
      open: false,
      extraText: "",
      screen: "payment",
    },
  };
  const [{ modalPayload }, setState] = useState(initialState);
  const updateState = (state: {}) => setState((prevState: any) => ({ ...prevState, ...state }));

  const [page, setPage] = useState(1);
  const [limit, _setLimit] = useState(50);
  const [rows, setRows] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [receiptCanApproveReceipts, setReceiptCanApproveReceipts] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [paymentColumns, setPaymentsColumns] = useState<any[]>([]);
  const [detectColumnChanges, setDetectColumnChanges] = useState(false);

  const [selectedUsageType, setSelectedUsageType] = useState(defaultUsageType);
  const [selectedProperty, setSelectedProperty] = useState<any>(null);
  const [selectedUnit, setSelectedUnit] = useState<any>(null);
  const [receiptStatusHeaderFilter, setReceiptStatusHeaderFilter] = useState<string | null>(null);
  const [paymentModeFilter, setPaymentModeFilter] = useState<{ value: string; label: string } | null>(null);
  const [dateFrom, setDateFrom] = useState<any>(null);
  const [dateTo, setDateTo] = useState<any>(null);

  const [drawer, setDrawer] = useState(false);
  const [updateValue, setUpdateValue] = useState<any>({});
  const [resetOwner, setResetOwner] = useState<any>(null);
  const [ownerName, setOwnerName] = useState("");

  const [leaseId, setLeaseId] = useState<string | null>(null);
  const [pdcIdFilter, setPdcIdFilter] = useState<string | null>(null);
  const [receiptNoFilter, setReceiptNoFilter] = useState<string | null>(null);
  const [receiptStatusFilter, setReceiptStatus] = useState<string | null>(null);
  const [approvalStatusFilter, setApprovalStatus] = useState<string | null>(null);
  const [tenantNameFilter, setTenantNameFilter] = useState<string | null>(null);
  const [landlordIdFilter, setLandlordIdFilter] = useState<string | null>(null);
  const [invoiceNumber, setInvoiceNumber] = useState<string | null>(null);
  // Receipt status is now merged into the header filter (no separate receipt status in More Filters).
  const [bankRefFilter, setBankRefFilter] = useState<string | null>(null);
  const [documentNoFilter, setDocumentNoFilter] = useState<string | null>(null);
  const [paymentTypeFilter, setPaymentTypeFilter] = useState<{ value: string; label: string } | null>(null);
  const [paidDateFrom, setPaidDateFrom] = useState<any>(null);
  const [paidDateTo, setPaidDateTo] = useState<any>(null);
  const [chequeDateFrom, setChequeDateFrom] = useState<any>(null);
  const [chequeDateTo, setChequeDateTo] = useState<any>(null);
  const [erpReceiptIdFilter, setErpReceiptIdFilter] = useState<string | null>(null);
  const [erpTenantIdFilter, setErpTenantIdFilter] = useState<string | null>(null);
  const [erpInvoiceNumberFilter, setErpInvoiceNumberFilter] = useState<string | null>(null);
  const [pendingBulkClearReceipts, setPendingBulkClearReceipts] = useState<any[]>([]);
  const [bulkClearModalOpen, setBulkClearModalOpen] = useState(false);
  const [isBulkClearLoading, setIsBulkClearLoading] = useState(false);

  const [visible, setVisible] = useState({ status: false, index: 0 });
  const [paymentStatusInfo, setPaymentStatusInfo] = useState<any>(null);
  const [selectedPDC, setSelectedPDC] = useState<any>(null);
  const [recallChequeActionType, setRecallChequeActionType] = useState<"apply" | "approveReject">("apply");
  const [selectedReceiptDocumentId, setSelectedReceiptDocumentId] = useState<string>("");

  const { owners } = useGetOwners();

  const canApproveReceipts =
    receiptCanApproveReceipts !== null
      ? receiptCanApproveReceipts
      : Boolean(pdcListState?.permissions?.canApproveReceipts);
  const units = useSelector((state: any) => state.propertyDetails.unitsDropdown);
  const properties = useSelector((state: any) => state.dashboard.propertiesDrop);

  const ownerFilterOptions = useMemo<OwnerFilterConfig[]>(() => {
    const defaultOptions: OwnerSelectOption[] = [{ value: "All Owners", label: "All Owners", a: "" }];
    const options = owners.length > 0 ? owners : defaultOptions;
    return [
      {
        name: "ownerId",
        label: `Owner (${Math.max(options.length - 1, 0)})`,
        placeholder: "All Owners",
        defaultValue: "All Owners",
        options,
      },
    ];
  }, [owners]);

  // =============================== intentionally commented out to avoid confusion ===============================

  // const paymentTypeUsageType = selectedUsageType === "all" ? "residential" : selectedUsageType;
  // const { paymentTypesOptions } = useGetPaymentTypeOptions({ usageType: paymentTypeUsageType });
  // const paymentTypeFilterOptions = useMemo<SelectOption[]>(() => {
  //   if (paymentTypesOptions.some((option: any) => option.value === defaultPaymentTypeOpt.value))
  //     return paymentTypesOptions;
  //   return [defaultPaymentTypeOpt, ...paymentTypesOptions];
  // }, [paymentTypesOptions]);

  // =============================== intentionally commented out to avoid confusion ===============================

  const defaultPropertyOpt = { label: "All Properties", value: "" };
  const defaultUnitOpt = { label: "All Units", value: "" };

  const [propertyOptions, setPropertyOptions] = useState<PropertyOption[]>([
    {
      name: "usageType",
      label: "Usage Type",
      initialValue: defaultUsageType,
      options: receiptsUsageTypeOptions,
    },
    {
      name: "property",
      label: "Property",
      search: true,
      initialValue: "",
      options: [defaultPropertyOpt],
    },
    {
      name: "unit",
      label: "Unit",
      search: true,
      initialValue: "",
      options: [],
    },
    {
      name: "status",
      label: "Receipt Status",
      initialValue: "All",
      options: receiptsStatusOptions,
    },
    {
      name: "Payment Mode",
      label: "Payment Modes",
      initialValue: "All",
      options: paymentModes,
    },
  ]);

  const getGridConfig = async () => {
    const result = await getGridSettings("receipts", receiptColumnDefs as any, resetGrid);

    // Reconcile persisted columns with new receipt columns so changes reflect immediately.
    const baseByField = new Map((receiptColumnDefs ?? []).map((c: any) => [c?.field, c]));
    const normalized = (Array.isArray(result) ? result : [])
      .filter((c: any) => c?.field && baseByField.has(c.field))
      .map((c: any) => {
        const base = baseByField.get(c.field);
        return base ? { ...base, ...c, headerName: c.headerName ?? base.headerName } : c;
      });
    const existing = new Set(normalized.map((c: any) => c.field));
    for (const base of receiptColumnDefs as any[]) {
      if (!base?.field || existing.has(base.field)) continue;
      normalized.unshift(base);
    }

    setPaymentsColumns(normalized);
    setGridReset(false);
  };

  useEffect(() => {
    getGridConfig();
  }, [resetGrid]);

  useEffect(() => {
    const finalUnitOptions = units?.length ? units : [];
    setPropertyOptions((prev) =>
      prev.map((opt) =>
        match(opt.name)
          .with("property", () => ({ ...opt, options: [defaultPropertyOpt, ...properties] }))
          .with("unit", () => ({ ...opt, options: [defaultUnitOpt, ...finalUnitOptions] }))
          .otherwise(() => opt),
      ),
    );
    if (properties.length === 0) dispatch(getPropertiesDrop());
  }, [properties, units]);

  useEffect(() => {
    dispatch(getPropertyUnits(selectedProperty?.propertyId, null, true));
    return () => {
      dispatch(emptyPropertyUnits());
    };
  }, [selectedProperty]);

  const buildQueryParams = useCallback(
    (overrides: { exportData?: boolean } = {}): Record<string, unknown> => {
      const params: Record<string, unknown> = {};
      if (leaseId) params["leaseId"] = leaseId;
      if (pdcIdFilter) params["pdcId"] = pdcIdFilter;
      if (receiptNoFilter) params["receiptNo"] = receiptNoFilter;
      if (receiptStatusFilter) params["receiptStatus"] = receiptStatusFilter;
      if (approvalStatusFilter) params["approvalStatus"] = approvalStatusFilter;
      if (selectedUsageType && selectedUsageType !== "all") params["usageType"] = selectedUsageType;
      if (selectedProperty?.property_name) params["propertyName"] = selectedProperty.property_name;
      if (selectedUnit) params["unitCode"] = selectedUnit;
      if (tenantNameFilter) params["tenantName"] = tenantNameFilter;
      if (paymentModeFilter?.value) params["paymentMode"] = paymentModeFilter.value;
      if (landlordIdFilter) params["landlordId"] = landlordIdFilter;
      if (ownerName) params["ownerName"] = ownerName;
      if (invoiceNumber) params["invoiceNumber"] = invoiceNumber;
      if (paymentTypeFilter?.value) params["paymentType"] = paymentTypeFilter.value;
      if (bankRefFilter) params["bankName"] = bankRefFilter;
      if (documentNoFilter) params["documentNo"] = documentNoFilter;
      if (dateFrom) params["dateFrom"] = dateByformat(dateFrom, DATE_FORMATS.api);
      if (dateTo) params["dateTo"] = dateByformat(dateTo, DATE_FORMATS.api);
      if (paidDateFrom) params["paidDateFrom"] = dateByformat(paidDateFrom, DATE_FORMATS.api);
      if (paidDateTo) params["paidDateTo"] = dateByformat(paidDateTo, DATE_FORMATS.api);
      if (chequeDateFrom) params["chequeDateFrom"] = dateByformat(chequeDateFrom, DATE_FORMATS.api);
      if (chequeDateTo) params["chequeDateTo"] = dateByformat(chequeDateTo, DATE_FORMATS.api);
      if (erpReceiptIdFilter) params["erpReceiptId"] = erpReceiptIdFilter;
      if (erpTenantIdFilter) params["erpTenantId"] = erpTenantIdFilter;
      if (erpInvoiceNumberFilter) params["erpInvoiceNumber"] = erpInvoiceNumberFilter;

      // Merged receipt status header filter overrides related params.
      const receiptStatusKey = receiptStatusHeaderFilter || "all";
      if (receiptStatusKey === "awaiting_approval") {
        params["approvalStatus"] = "pending_confirmation";
      } else if (receiptStatusKey === "not_cleared") {
        params["isCleared"] = false;
      } else if (receiptStatusKey === "cleared") {
        params["isCleared"] = true;
      } else if (receiptStatusKey === "incoming_transfer") {
        params["paymentMode"] = "bank_transfer";
        params["approvalStatus"] = "pending_confirmation";
      } else if (receiptStatusKey === "recalled") {
        params["receiptStatus"] = "recalled";
      } else if (receiptStatusKey === "bounced") {
        params["receiptStatus"] = "bounced";
      } else if (receiptStatusKey === "deferred") {
        params["receiptStatus"] = "deferred";
      } else if (receiptStatusKey === "cancelled") {
        params["receiptStatus"] = "cancelled";
      } else if (receiptStatusKey === "paid") {
        params["receiptStatus"] = "paid";
      }

      if (!overrides.exportData) {
        params["page"] = page;
        params["limit"] = limit;
      }
      return params;
    },
    [
      leaseId,
      pdcIdFilter,
      receiptNoFilter,
      receiptStatusFilter,
      approvalStatusFilter,
      selectedUsageType,
      selectedProperty?.property_name,
      selectedUnit,
      tenantNameFilter,
      paymentModeFilter?.value,
      landlordIdFilter,
      ownerName,
      invoiceNumber,
      paymentTypeFilter?.value,
      bankRefFilter,
      documentNoFilter,
      dateFrom,
      dateTo,
      paidDateFrom,
      paidDateTo,
      chequeDateFrom,
      chequeDateTo,
      erpReceiptIdFilter,
      erpTenantIdFilter,
      erpInvoiceNumberFilter,
      receiptStatusHeaderFilter,
      page,
      limit,
    ],
  );

  const fetchReceipts = useCallback(async () => {
    setIsLoading(true);
    try {
      const params = buildQueryParams();

      const data = await getReceiptList(params, paymentReceiptId);
      const result = paymentReceiptId ? [data?.result] : data?.result || [];
      const list: any[] = Array.isArray(result?.data) ? result.data : Array.isArray(result) ? result : [];
      const normalized = list.map(normalizeReceiptRow);
      setRows(normalized);
      setTotalCount(result?.totalCount ?? result?.total ?? normalized.length);

      const listPerm = paymentReceiptId ? data?.result?.permissions : result?.permissions;
      if (listPerm && typeof listPerm.canApproveReceipts === "boolean") {
        setReceiptCanApproveReceipts(listPerm.canApproveReceipts);
      }
      setPendingBulkClearReceipts([]);
    } catch (e) {
      setRows([]);
      setTotalCount(0);
    } finally {
      setIsLoading(false);
    }
  }, [buildQueryParams]);

  useEffect(() => {
    fetchReceipts();
  }, [fetchReceipts, paymentReceiptId]);

  useEffect(() => {
    if (paymentStatusInfo?.selectedOption === "history") {
      const payload = {
        iKey: "11",
        width: "80%",
        extraText: "",
        title: "Change History",
        screen: "payment",
      };
      updateState({ modalPayload: { ...payload, open: true } });
    }
  }, [paymentStatusInfo?.selectedOption, paymentStatusInfo]);

  const handlePagination = (next: number) => {
    setPage(next);
  };

  const handlePropertyChange = (property: any, label: string) => {
    if (label === "usageType") {
      setSelectedUsageType(property?.value);
      setUpdateValue([{ label: "unit", value: "" }]);
    } else if (label === "property") {
      setUpdateValue([{ label: "unit", value: "" }]);
      setSelectedUnit(null);
      setSelectedProperty({ propertyId: property?.value, property_name: property?.label });
    } else if (label === "unit" && property?.label !== null) {
      // Receipts API expects `unitCode` (string), not unit id.
      setSelectedUnit(property?.label === "All Units" ? "" : property?.label || property?.value);
    } else if (label === "status" && property?.value !== null) {
      const next = property?.value === "all" ? null : property?.value;
      setReceiptStatusHeaderFilter(next);
    } else if (label === "Payment Mode") {
      property?.value === "all"
        ? setPaymentModeFilter(null)
        : setPaymentModeFilter({ value: property?.value, label: property?.label });
    }
    if (paymentReceiptId) {
      navigate("/receipts", { replace: true });
    }
    setPage(1);
  };

  const handleOwnerSelect = (selectedValue: any, selectedOption?: any) => {
    setResetOwner(null);
    if (selectedValue === "All Owners" || selectedValue === undefined || selectedValue === "") {
      setOwnerName("");
    } else {
      const name =
        selectedOption?.label ??
        ownerFilterOptions[0]?.options.find((opt: OwnerSelectOption) => opt.value === selectedValue)?.label ??
        selectedValue;
      if (name) {
        setOwnerName(name);
      }
    }
    if (paymentReceiptId) {
      navigate("/receipts", { replace: true });
    }
    setPage(1);
  };

  const resetAllFilters = () => {
    setSelectedUnit(null);
    setSelectedProperty(null);
    setOwnerName("");
    setResetOwner("reset");
    setDateFrom(null);
    setDateTo(null);
    setPaidDateFrom(null);
    setPaidDateTo(null);
    setChequeDateFrom(null);
    setChequeDateTo(null);
    setLeaseId(null);
    setPdcIdFilter(null);
    setReceiptNoFilter(null);
    setReceiptStatus(null);
    setApprovalStatus(null);
    setTenantNameFilter(null);
    setLandlordIdFilter(null);
    setInvoiceNumber(null);
    setBankRefFilter(null);
    setDocumentNoFilter(null);
    setPaymentTypeFilter(null);
    setReceiptStatusHeaderFilter(null);
    setPaymentModeFilter(null);
    setUpdateValue([
      { label: "usageType", value: defaultUsageType },
      { label: "property", value: "" },
      { label: "unit", value: "" },
      { label: "status", value: "all" },
      { label: "Payment Mode", value: "all" },
    ]);
    setSelectedUsageType(defaultUsageType);
    setPage(1);
  };

  const downloadAction = async () => {
    try {
      await postReceiptExport({
        query: buildQueryParams({ exportData: true }),
        columns:
          receiptExportColumns(paymentColumns)?.length > 0
            ? receiptExportColumns(paymentColumns)
            : RECEIPT_EXPORT_COLUMNS,
      });
      message.success("Export in progress. You will receive the exported file in your email in few minutes");
    } catch (e) {
      message.error("Failed to export receipts");
    }
  };

  const onUpdate = () => {
    setVisible({ status: false, index: 0 });
    fetchReceipts();
  };

  const onCancel = () => {
    setVisible({ status: false, index: 0 });
  };

  const openModalAction = (data: any) => {
    setPaymentStatusInfo(data);
    setVisible({ status: true, index: 2 });
  };

  const openPrintReceiptModal = useCallback((row: any) => {
    const documentId =
      row?.receiptDocumentId || row?.paymentReceipts?.[0]?.receiptDocumentId || row?.receipt?.documentId || "";
    if (!documentId) {
      message.info("Receipt document not found");
      return;
    }
    setSelectedReceiptDocumentId(String(documentId));
    setVisible({ status: true, index: 9 });
  }, []);

  const handleAction = useCallback(
    async (action: string, row: any) => {
      if (action === "history") {
        setPaymentStatusInfo({ params: { data: row }, selectedOption: action });
        return;
      }
      if (action === "printReceipt") {
        openPrintReceiptModal(row);
        return;
      }
      if (action === "approveRejectReceipt") {
        setPaymentStatusInfo({
          params: { data: row },
          selectedOption: action,
        });
        setVisible({ status: true, index: 10 });
        return;
      }
      const pdcId = row?.pdcId || row?.pdc?.pdcId || row?.intendedAllocations?.[0]?.pdcId || row?._id;
      if (!pdcId) {
        message.error("Missing PDC ID for this receipt");
        return;
      }

      try {
        const coalesceText = (...values: any[]) => {
          for (const value of values) {
            if (typeof value === "string" && value.trim() !== "") return value;
          }
          return "";
        };

        const merged = {
          paymentReceiptId: row?.paymentReceiptId,
          approvalStatus: row?.approvalStatus,
          deferDate: row?.defer?.approvedAt,
          recallDate: row?.recall?.approvedAt,
          statusHistory: Array.isArray(row?.statusHistory) ? row.statusHistory : [],
          receiptNo: row?.receiptNo ?? "",
          totalAmount: row?.totalAmount ?? 0,
          amount: row?.totalAmount ?? 0,
          paidDate: row?.paymentDate ?? "",
          documentNo: row?.paymentDetails?.chequeNo ?? "",
          paymentMode: row?.paymentMode ?? "",
          paymentStatus: row?.paymentStatus ?? "",
          chequeStatus: row?.paymentStatus ?? "",
          chequeDate: row?.pdc?.chequeDate ?? null,
          chequeNumber: row?.pdc?.chequeNumber ?? "",
          paymentDetails: {
            ...(row?.paymentDetails || {}),
          },
          recall: {
            ...(row?.recall || {}),
          },
          bankName: row?.paymentDetails?.bankName || row?.bankName,
          depositTo: coalesceText(
            row?.depositTo,

            row?.beneficiaryName,

            row?.lessorName,

            row?.ownerName,
          ),
          depositToBank: coalesceText(
            row?.depositToBank,

            row?.beneficiaryBank,

            row?.lessorBankName,
          ),
          beneficiaryName: coalesceText(row?.beneficiaryName),
          beneficiaryBank: coalesceText(row?.beneficiaryBank),
          lessorBankName: coalesceText(row?.lessorBankName),
          propertyDetails: {
            ...(row?.propertyDetails || {}),
            usagesType:
              row?.propertyDetails?.usagesType ||
              (selectedUsageType !== "all" ? selectedUsageType : "residential") ||
              "residential",
          },
        };

        const params = { data: { ...merged, currentStaus: merged?.paymentStatus } };

        if (action === "mark_as_bounced") {
          setPaymentStatusInfo({
            paymentMode: merged?.paymentMode,
            params,
            isNew: true,
            selectedOption: action,
            paymentReceiptId: merged?.paymentReceiptId,
          });
          setVisible({ status: true, index: 2 });
        } else if (action === "replace_cheque") {
          setPaymentStatusInfo({
            paymentMode: merged?.paymentMode,
            params: {
              data: {
                ...merged,
                chequeStatus: "bounce",
                currentStaus: "bounce",
                bounceToPending: true,
                paymentReceiptId: merged?.paymentReceiptId,
                paymentMode: merged?.paymentMode || "",
              },
            },
            isNew: true,
            selectedOption: action,
          });
          setVisible({ status: true, index: 2 });
        } else if (action === "mark_cleared") {
          setPaymentStatusInfo({
            paymentMode: merged?.paymentMode,
            params,
            isNew: true,
            selectedOption: action,
          });
          setVisible({ status: true, index: 7 });
        } else if (action === "defer_cheque_deposit") {
          setPaymentStatusInfo({
            paymentMode: merged?.paymentMode,
            params,
            isNew: true,
            selectedOption: action,
          });
          setVisible({ status: true, index: 5 });
        } else if (action === "recallCheque") {
          setRecallChequeActionType("apply");
          setSelectedPDC(merged);
          setVisible({ status: true, index: 8 });
        } else if (action === "approveRejectRecallCheque") {
          setRecallChequeActionType("approveReject");
          setSelectedPDC(merged);
          setVisible({ status: true, index: 8 });
        }
      } catch (e) {
        message.error("Failed to load PDC details");
      }
    },
    [openPrintReceiptModal, selectedUsageType],
  );

  const data = paymentStatusInfo && _.cloneDeep(paymentStatusInfo);

  const popup: any[] = [
    { title: null, content: null, width: 400 },
    { title: null, content: null, width: 400 },
    {
      title: (
        <Title level={3} className="mb-0">
          {`Edit Receipt ${data?.params?.data?.receiptNo || ""}`}
        </Title>
      ),
      content: (
        <ModifyPaymentStatus
          data={data}
          onUpdate={onUpdate}
          onCancel={onCancel}
          getAllPayments={fetchReceipts}
          organization={organization}
          openModalAction={openModalAction}
          selectedOption={paymentStatusInfo?.selectedOption}
          paymentReceiptId={paymentStatusInfo?.paymentReceiptId}
        />
      ),
      width: 900,
      style: { padding: "0px" },
    },
    { title: null, content: null, width: 400 },
    { title: null, content: null, width: 400 },
    {
      title: (
        <Title level={3} className="mb-0">
          {`Defer Cheque ${data?.params?.data?.receiptNo || ""}`}
        </Title>
      ),
      content: (
        <DeferChequeDeposit
          data={data}
          onUpdate={onUpdate}
          onCancel={onCancel}
          getAllPayments={fetchReceipts}
          openModalAction={openModalAction}
        />
      ),
      width: 850,
      style: { padding: "0px" },
    },
    { title: null, content: null, width: 400 },
    {
      title: <PopupTitle title={`Select Cheque to Clear ${data?.params?.data?.receiptNo || ""}`} />,
      content: (
        <ChequeClearModal
          onSuccess={() => {
            setVisible({ status: false, index: 7 });
            fetchReceipts();
          }}
          setVisible={setVisible}
          data={data}
          isReceiptEnabled={isReceiptEnabled}
        />
      ),
      width: 850,
      style: { padding: 0 },
    },
    {
      title: (
        <PopupTitle
          title={`${recallChequeActionType === "approveReject" ? "Approve/Reject" : ""} Recall Cheque for ${selectedPDC?.receiptNo || selectedPDC?.invoiceNumber || ""}`}
        />
      ),
      content: (
        <RecallCheque
          invoice={selectedPDC}
          actionType={recallChequeActionType}
          onSuccess={() => {
            setVisible({ status: false, index: 8 });
            fetchReceipts();
          }}
          onClose={() => setVisible({ status: false, index: 8 })}
        />
      ),
      width: "62rem",
      style: { padding: 0 },
    },
    {
      title: <PopupTitle title="Document" />,
      content: (
        <DocumentViewer
          documentId={selectedReceiptDocumentId}
          onClose={() => setVisible({ status: false, index: 9 })}
        />
      ),
      width: 1200,
      style: { padding: 0 },
    },
    {
      title: (
        <PopupTitle
          title={`Approve/Reject Receipt for ${data?.params?.data?.receiptNo || data?.params?.data?.invoiceNumber || ""}`}
        />
      ),
      content: (
        <ReceiptConfirmation
          onSuccess={() => {
            setVisible({ status: false, index: 10 });
            fetchReceipts();
          }}
          setVisible={setVisible}
          data={data}
          successRedirectPath="/receipts"
          isReceiptPage={true}
        />
      ),
      width: "65rem",
      style: { padding: 0 },
    },
  ];

  const popupProps = {
    closable: true,
    visibility: visible.status,
    title: popup[visible.index]?.title,
    content: popup[visible.index]?.content,
    width: popup[visible.index]?.width,
    style: popup[visible.index]?.style,
    onCancel: () => {
      setVisible({ status: false, index: 0 });
      setSelectedPDC(null);
    },
  };

  const effectivePaymentColumns = useMemo(() => {
    const hiddenReceiptFields = new Set(["description", "vat", "vatInPercentage", "actualAmount", "balance"]);
    if (!Array.isArray(paymentColumns) || paymentColumns.length === 0) {
      return (receiptColumnDefs as any[]).filter((col: any) => !hiddenReceiptFields.has(col?.field));
    }
    const filteredPaymentColumns = paymentColumns.filter((col: any) => !hiddenReceiptFields.has(col?.field));
    const hasActionsColumn = paymentColumns.some(
      (col: any) =>
        col?.field === "action" || col?.field === "actions" || col?.id === "actions" || col?.headerName === "Actions",
    );
    if (hasActionsColumn) return filteredPaymentColumns;
    const actionColumn = (receiptColumnDefs as any[]).find((col: any) => col?.field === "action");
    return actionColumn ? [...filteredPaymentColumns, actionColumn] : filteredPaymentColumns;
  }, [paymentColumns]);

  const columns = useMemo(
    () => buildReceiptColumns(effectivePaymentColumns, handleAction, organization, canApproveReceipts),
    [effectivePaymentColumns, handleAction, organization, canApproveReceipts],
  );

  const onSelectionChanged = ({ api }: any) => {
    const selected: any[] = [];
    api.getSelectedNodes().forEach((node: any) => {
      const row = node?.data;
      if (isReceiptBulkSelectionRow(row) && row?.paymentReceiptId) {
        selected.push(row);
      }
    });
    setPendingBulkClearReceipts(selected);
  };

  const closeBulkClearModal = useCallback(() => {
    setBulkClearModalOpen(false);
  }, []);

  const handleBulkClearConfirm = useCallback(
    async (paymentReceiptIds: string[], clearedDate: string) => {
      if (paymentReceiptIds.length === 0 || !clearedDate) return;
      setIsBulkClearLoading(true);
      try {
        await postReceiptChequeClear({ paymentReceiptIds, isCleared: true, clearedDate });
        message.success(
          paymentReceiptIds.length === 1
            ? "Receipt cleared successfully"
            : `${paymentReceiptIds.length} receipts cleared successfully`,
        );
        closeBulkClearModal();
        fetchReceipts();
      } catch {
        message.error("Failed to clear receipt(s)");
      } finally {
        setIsBulkClearLoading(false);
      }
    },
    [closeBulkClearModal, fetchReceipts],
  );

  const handleSetDateFrom = useCallback(
    (date: any) => {
      setDateFrom(date);
      if (paymentReceiptId) {
        navigate("/receipts", { replace: true });
      }
    },
    [paymentReceiptId, navigate],
  );

  const handleSetDateTo = useCallback(
    (date: any) => {
      setDateTo(date);
      if (paymentReceiptId) {
        navigate("/receipts", { replace: true });
      }
    },
    [paymentReceiptId, navigate],
  );

  return (
    <>
      <DashboardLayout>
        <Row gutter={[32, 32]}>
          <Col span={24}>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <ReceiptsHeader
                  total={totalCount}
                  viewOption={propertyOptions}
                  updateValue={updateValue}
                  handleView={handlePropertyChange}
                  setDateTo={handleSetDateTo}
                  dateTo={dateTo}
                  setDateFrom={handleSetDateFrom}
                  dateFrom={dateFrom}
                  setDrawer={setDrawer}
                  downloadAction={downloadAction}
                  actionButtons={
                    pendingBulkClearReceipts.length > 0 ? (
                      <Button
                        size="large"
                        type="primary"
                        className="property_card_btn"
                        onClick={() => setBulkClearModalOpen(true)}
                      >
                        Clear Receipts
                      </Button>
                    ) : null
                  }
                />
              </Col>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.75rem",
                  width: "100%",
                  marginInline: "0.75rem",
                }}
              >
                <div style={{ flex: 1 }}>
                  <Pagination
                    className="ag-property-text-pagination"
                    total={totalCount || 0}
                    showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} Receipts`}
                    defaultCurrent={1}
                    pageSize={limit}
                    showSizeChanger={false}
                    current={page}
                    onChange={handlePagination}
                  />
                </div>
                <DragAndDropList
                  columns={paymentColumns}
                  setModifiedColumns={setPaymentsColumns}
                  changePicker={setDetectColumnChanges}
                  detectColumnChanges={detectColumnChanges}
                  screenName="receipts"
                  hiddenFields={["receiptNo"]}
                  setGridReset={setGridReset}
                />
              </div>

              <Col span={24}>
                <Row gutter={[24, 24]} justify="end">
                  <Col span={24}>
                    <Card bordered={false} className="ag-nospace-body">
                      {isLoading ? (
                        <Loader />
                      ) : (
                        <Grid
                          rowSelection="multiple"
                          data={rows}
                          columns={columns}
                          pagination={false}
                          defaultSettings={defaultSettings}
                          noRowlabel="Receipts"
                          fullPage={true}
                          overlayNoRowsTemplate={"Receipts data not found."}
                          onSelectionChanged={onSelectionChanged}
                        />
                      )}
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>

          <SideDrawer
            openDrawer={drawer}
            closeDrawer={setDrawer}
            width={"410px"}
            title={"More Search Options"}
            mask={false}
            placement="right"
          >
            <ReceiptsAdditionalFilters
              setReceiptNoFilter={setReceiptNoFilter}
              setTenantNameFilter={setTenantNameFilter}
              setInvoiceNumber={setInvoiceNumber}
              setBankRefFilter={setBankRefFilter}
              setDocumentNoFilter={setDocumentNoFilter}
              setPaymentTypeFilter={setPaymentTypeFilter}
              setErpReceiptIdFilter={setErpReceiptIdFilter}
              setErpTenantIdFilter={setErpTenantIdFilter}
              setErpInvoiceNumberFilter={setErpInvoiceNumberFilter}
              setPaidDateFrom={setPaidDateFrom}
              setPaidDateTo={setPaidDateTo}
              paidDateFrom={paidDateFrom}
              paidDateTo={paidDateTo}
              filterReset={resetAllFilters}
              onAfterFilterSubmit={() => {
                setPage(1);
                if (paymentReceiptId) {
                  navigate("/receipts", { replace: true });
                }
              }}
              ownerFilterOptions={ownerFilterOptions}
              onOwnerSelect={handleOwnerSelect}
              resetOwner={resetOwner}
              ownerFilterOption={(inputValue: string, option: any) => {
                if (!inputValue || inputValue === "All Owners") {
                  return true;
                }
                const options = ownerFilterOptions[0]?.options ?? [];
                const isExactOwnerSelection = options.some(
                  (opt) => opt.label === inputValue && opt.value !== "All Owners",
                );
                if (isExactOwnerSelection) {
                  return true;
                }
                return option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
              }}
            />
          </SideDrawer>
        </Row>
      </DashboardLayout>
      {paymentStatusInfo && paymentStatusInfo?.selectedOption === "history" && (
        <Modal
          className="bd-modal"
          modalPayload={modalPayload}
          updateState={updateState}
          historyData={paymentStatusInfo?.params?.data?.statusHistory}
        />
      )}
      <Popup destroyOnClose={true} {...popupProps} />
      <Popup
        destroyOnClose={true}
        closable={true}
        visibility={bulkClearModalOpen}
        title={<PopupTitle title="Clear Receipts" />}
        content={
          <BulkClearedReceiptsConfirm
            receipts={pendingBulkClearReceipts}
            onConfirm={handleBulkClearConfirm}
            onClose={closeBulkClearModal}
            isLoading={isBulkClearLoading}
          />
        }
        width="80rem"
        style={{ padding: 0 }}
        onCancel={closeBulkClearModal}
      />
    </>
  );
};

export default React.memo(Receipts);
